import React from 'react';
import styles from './ErrorContent.module.css';

export default class ErrorContent extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {

        var error = this.props.error;

        return (
            <div styleName="styles.errorMessage">
                {
                    error && <p>{error.message}</p>
                }
            </div>
            );
    }
}